const MAX_SIZE = 6 * 1024 * 1024; // 6MB
const MAX_DIMENSION = 4096;
const INITIAL_QUALITY = 0.92;
const QUALITY_STEP = 0.1;
const MIN_QUALITY = 0.52;

async function compressToJpeg(bitmap, maxWidth, maxHeight, quality) {
  const canvas = new OffscreenCanvas(maxWidth, maxHeight);
  const ctx = canvas.getContext("2d");
  ctx.drawImage(bitmap, 0, 0, maxWidth, maxHeight);
  return canvas.convertToBlob({ type: "image/jpeg", quality });
}

function scaledDimensions(width, height, maxDimension) {
  if (width <= maxDimension && height <= maxDimension) return { width, height };

  const ratio = Math.min(maxDimension / width, maxDimension / height);
  return {
    width: Math.round(width * ratio),
    height: Math.round(height * ratio),
  };
}

function jpegFileName(originalName) {
  const base = originalName.replace(/\.[^.]+$/, "");
  return `${base}.jpg`;
}

export async function compressImage(file) {
  if (!file.type.startsWith("image/")) return file;
  if (file.type === "image/gif" && file.size <= MAX_SIZE) return file;

  const bitmap = await createImageBitmap(file);
  let { width, height } = scaledDimensions(bitmap.width, bitmap.height, MAX_DIMENSION);

  while (true) {
    let quality = INITIAL_QUALITY;

    while (quality >= MIN_QUALITY) {
      const blob = await compressToJpeg(bitmap, width, height, quality);
      if (blob.size <= MAX_SIZE) {
        return new File([blob], jpegFileName(file.name), {
          type: "image/jpeg",
        });
      }
      quality -= QUALITY_STEP;
    }

    width = Math.round(width / 2);
    height = Math.round(height / 2);
  }
}
